import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Flex, Input } from '@chakra-ui/react';
import Text from '@molecules/Text';
import Button from '@molecules/Button';
import Card from '@molecules/Card';
import BEIcon from '@molecules/BEIcon';
import { system } from '@config/system';
import { CbLogo } from '@view/components/CbLogo';
const Main = () => {
    const [url, setURL] = useState('');
    // On this part of the code we want to redirect using location.href
    // to force a page reload, initializing with the new URL.
    const onClickOpenProperty = useCallback(() => {
        const loc = new URL(url);
        window.location.href = loc.pathname;
    }, [url]);
    return (_jsx(Flex, { "data-testid": "dev-index-page", justifyContent: "center", p: "20px", w: "100%", children: _jsxs(Flex, { alignItems: "center", flexDir: "column", gap: "20px", maxW: "640px", textAlign: "center", w: "100%", children: [_jsx(CbLogo, { width: "200px" }), _jsxs(Card, { children: [_jsxs(Text, { fontWeight: 600, mb: 2, size: "xl", children: ["BookingEngine ", system.environment] }), _jsxs(Flex, { gap: "16px", children: [_jsx(Input, { _placeholder: { opacity: 0.6 }, bg: "white", onChange: (e) => setURL(e.target.value), placeholder: "Booking Engine url...", value: url }), _jsx(Button, { onClick: onClickOpenProperty, children: "Open" })] }), _jsxs(Flex, { alignItems: "center", gap: "8px", mt: "8px", children: [_jsx(BEIcon, { color: "neutral", name: "info-circle" }), _jsx(Text, { color: "neutral", size: "sm", textAlign: "left", children: "Enter the url of the Cloudbeds's booking engine you want to try on the new v3 system." })] })] })] }) }));
};
export default Main;
